
import "./Playernews.css";
// import ffc from "../../teamImage/ffc.png";
// import manU from "../../teamImage/manU.png";
// import she from "../../teamImage/she.png";
import kelvin from "../../teamImage/kelvin.jpg";
import series from "../../teamImage/series.jpg";
import backArrow from "../../../../images/arrow.png";
      import whiteArrow from "../../../../images/white-arrow.png";
import { NavLink } from "react-router-dom";

const Playernews = ({dark}) => {
    return <div className="playerdetailWrapper" style={dark ? {backgroundColor: "#111111e7"} : {}}>
        
      <NavLink className="strong" to="/teams/details" style={{ cursor: "pointer" }}>
        ←
      </NavLink>
        
        <section className="firstsection">
            <nav>
                <img src={kelvin} alt="" />
                <div>
                    <p style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Kelvin Williams</p>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>22 years,  England</strong>
                    <strong style={dark ? {color: "#e2e1e1ff"} : {color: "#3F3E3E"}}>Manchester city</strong>
                </div>
            </nav>
            <menu>
                <ul style={dark ? {backgroundColor: "#131313ff"} : {}}>
                    <li><NavLink to="/teams/players" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>Overview</NavLink></li>
                    <li><NavLink to="/teams/player/news" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {}}>News</NavLink></li>
                    <li><NavLink to="/teams/player/statistics" className="linkname"
                     style={dark ? {color: "#fafafaff"} : {color: "#3F3E3E"}}>Statistics</NavLink></li>
                </ul>
            </menu>
        </section>

        <h1 style={dark ? {color: "#fafafaff"} : {color: "#161819"}}>Player News</h1>

        <section className="fifthsection">
                    <div style={dark ? {backgroundColor: "#181818ff"} : {backgroundColor: "#38BE8F"}}>
                        <nav>
                            <img src={series} alt="" />
                        </nav>
                        <nav className="con">
                                <h3>Series A</h3>
                                <h2>Watch your favorite team</h2>
                                <p>Watch your favorite team compete in real-time.
                                    Tune in now and experience the thrill of Saudi football - live</p>
                        </nav>
                    </div>
                    <div style={dark ? {backgroundColor: "#181818ff"} : {backgroundColor: "#5126D4"}}>
                        <nav>
                            <img src={series} alt="" />
                        </nav>
                        <nav className="con">
                                <h3>Series A</h3>
                                <h2>Watch your favorite team</h2>
                                <p>Watch your favorite team compete in real-time.
                                    Tune in now and experience the thrill of Saudi football - live</p>
                        </nav>
                    </div>
                    <div  style={dark ? {backgroundColor: "#181818ff"} : {backgroundColor: "#389A3F"}}>
                        <nav>
                            <img src={series} alt="" />
                        </nav>
                        <nav className="con">
                                <h3>Series A</h3>
                                <h2>Watch your favorite team</h2>
                                <p>Watch your favorite team compete in real-time.
                                    Tune in now and experience the thrill of Saudi football - live</p>
                        </nav>
                    </div>
        </section>
        
        <section className="sixthsection">
            
            <div>
                <nav>
                    <img src={series} alt="" />
                </nav>
                <nav className="con">
                        <h3>Series A</h3>
                        <h2>Watch your favorite team</h2>
                        <p>Watch your favorite team compete in real-time. Tune in now and
                                experience the thrill of Saudi football - live.Watch your favorite
                                team compete in real-time. Tune in now and experience the thrill of
                                Saudi football - live</p>
                </nav>
            </div>
            
            <div>
                <nav>
                    <img src={series} alt="" />
                </nav>
                <nav className="con">
                        <h3>Series A</h3>
                        <h2>Watch your favorite team</h2>
                        <p>Watch your favorite team compete in real-time. Tune in now and
                                experience the thrill of Saudi football - live.Watch your favorite
                                team compete in real-time. Tune in now and experience the thrill of
                                Saudi football - live</p>
                </nav>
            </div>
            
            <div>
                <nav>
                    <img src={series} alt="" />
                </nav>
                <nav className="con">
                        <h3>Series A</h3>
                        <h2>Watch your favorite team</h2>
                        <p>Watch your favorite team compete in real-time. Tune in now and
                                experience the thrill of Saudi football - live.Watch your favorite
                                team compete in real-time. Tune in now and experience the thrill of
                                Saudi football - live</p>
                </nav>
            </div>
        </section>



    </div>
}

export default  Playernews;